import { ReactNode } from "react";
import { Link } from "react-router-dom";
import AppLayout from "./AppLayout";

type LoginLayoutProps = {
  title: string;
  children: ReactNode;
  link?: string;
  logo: string;
  loginImage: string;
  childrenClass?: string;
};

export default function LoginLayout({
  title,
  link,
  children,
  logo,
  loginImage,
  childrenClass,
}: LoginLayoutProps) {
  return (
    <AppLayout title={title}>
      <section className="min-h-[500px] grid lg:grid-cols-2 h-screen bg-white">
        <div className="hidden lg:flex justify-center items-center h-full relative">
          <Link to={link ?? "/"}>
            <img
              className="object-contain absolute left-7 top-7"
              src={logo}
              alt="Logo"
            />
          </Link>
          <img
            className="max-h-[400px] object-contain"
            src={loginImage}
            alt="Login"
          />
        </div>

        <div
          className={`w-full h-full p-12 bg-[#fbf4ff] flex justify-center items-center ${childrenClass}`}
        >
          {children}
        </div>
      </section>
    </AppLayout>
  );
}
